import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { SupportEmailDialogComponent } from '@app/components/home/support-email-dialog/support-email-dialog.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgIf } from '@angular/common';

@Component({
  selector: 'app-support-icon',
  templateUrl: './support-icon.component.html',
  styleUrls: ['./support-icon.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgIf],
})
export class SupportIconComponent {
  @Input()
  renderAsMenuOption = false;

  constructor(private modalService: NgbModal) {}

  openSupportDialog() {
    this.modalService.open(SupportEmailDialogComponent, {
      size: 'lg',
    });
  }
}
